<template>
  <div class="bg-white rounded-2xl shadow-lg border-l-4 border-psychology-primary p-6">
    <div class="flex items-center gap-3 mb-4">
      <div class="w-6 h-6 rounded-full bg-psychology-primary flex items-center justify-center text-white font-bold text-sm">
        !
      </div>
      <h3 class="text-xl font-semibold text-psychology-primary">结果解释</h3>
    </div>

    <div class="space-y-4">
      <!-- 结果解释内容 -->
      <div class="text-gray-700 leading-relaxed">
        <p>你的年上年下倾向指数为<strong class="text-psychology-primary">{{ aypScore }}</strong>分，属于<strong class="text-psychology-primary">[{{ levelText }}]</strong>。</p>
        <p class="mt-2">{{ description }}</p>
      </div>

      <!-- 高得分维度 -->
      <div v-if="highDimensions.length > 0" class="mt-4">
        <h4 class="font-semibold text-gray-900 mb-2">在以下维度得分较高</h4>
        <div class="flex flex-wrap gap-2">
          <span 
            v-for="dimension in highDimensions" 
            :key="dimension"
            class="px-3 py-1 bg-psychology-primary/10 text-psychology-primary rounded-full text-sm font-medium"
          >
            {{ dimension }}
          </span>
        </div>
      </div>
      <div v-else class="mt-4">
        <h4 class="font-semibold text-gray-900 mb-2">各维度得分较为均衡</h4>
        <p class="text-gray-600 text-sm">你的恋爱关系模式在各维度上表现较为均衡。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getAYPLevel } from '@/utils/aypCalculator'

export default {
  name: 'ResultExplanation',
  props: {
    aypScore: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100
    },
    scores: {
      type: Object,
      required: true
    }
  },
  computed: {
    levelText() {
      return getAYPLevel(this.aypScore)
    },
    description() {
      const level = this.levelText
      if (level.includes('极强年上') || level.includes('强烈年上')) {
        return '这表明你在恋爱关系中更倾向于寻找比自己年长的伴侣。'
      } else if (level.includes('明显年上') || level.includes('年上倾向')) {
        return '这表明你在恋爱关系中比较倾向于寻找比自己年长的伴侣。'
      } else if (level.includes('平衡')) {
        return '这表明你在恋爱关系中对伴侣年龄没有特别偏好。'
      } else if (level.includes('明显年下') || level.includes('年下倾向')) {
        return '这表明你在恋爱关系中比较倾向于寻找比自己年轻的伴侣。'
      } else {
        return '这表明你在恋爱关系中更倾向于寻找比自己年轻的伴侣。'
      }
    },
    highDimensions() {
      const dimensionNames = {
        MAT: '成熟偏好',
        CAR: '照顾需求',
        GUI: '引导欲望',
        IND: '独立倾向'
      }
      
      const highDims = []
      // 检查所有维度
      Object.keys(dimensionNames).forEach(key => {
        if (this.scores[key] !== undefined && this.scores[key] >= 80) {
          highDims.push(dimensionNames[key])
        }
      })
      
      return highDims
    }
  }
}
</script>

